export default __webpack_public_path__ + "static/media/English(US).2434196c.svg";